import { NgModule } from '@angular/core';
import { VsnrTranformationPipe } from './vsnr.pipe';
import {
    MoneyCorrectionTranformationPipe,
    MoneyTranformationPipe,
    PercentCalculatePipe,
    PercentFormatPipe
} from './money.pipe';
import { DynamicPipe } from './dynamic.pipe';
import {
    DateInput2DateValuePipe,
    DateTimeArray2DateTimePipe,
    DateValue2DateInputPipe,
    YearPickerPipe
} from './date.pipe';
import { CustomerPickerPipe } from './customer.pipe';
import { ByteToHumanReadablePipe, ByteToKiloPipe, ByteToMegaPipe } from './bytes.pipe';

@NgModule({
    imports: [],
    declarations: [
        VsnrTranformationPipe,
        MoneyTranformationPipe,
        MoneyCorrectionTranformationPipe,
        PercentCalculatePipe,
        DynamicPipe,
        YearPickerPipe,
        CustomerPickerPipe,
        ByteToMegaPipe,
        ByteToKiloPipe,
        ByteToHumanReadablePipe,
        PercentFormatPipe,
        DateValue2DateInputPipe,
        DateTimeArray2DateTimePipe,
        DateInput2DateValuePipe,
    ],
    exports: [
        VsnrTranformationPipe,
        MoneyTranformationPipe,
        MoneyCorrectionTranformationPipe,
        PercentCalculatePipe,
        DynamicPipe,
        YearPickerPipe,
        CustomerPickerPipe,
        ByteToMegaPipe,
        ByteToKiloPipe,
        ByteToHumanReadablePipe,
        PercentFormatPipe,
        DateValue2DateInputPipe,
        DateTimeArray2DateTimePipe,
        DateInput2DateValuePipe,
    ],
})
export class PipeModule {
}
